import React from "react";

const CoreComponent4 = ({ content }) => {
  return (
    <div className="row mt-80  pb-4 overflow-hidden mart">
      {content.map((val, i) => (
        <div
          className=" col-md-6 col-11 mb-4 mx-auto "
          style={{ width: "", height: '' }}
          key={i}
        >
          <div className="p-4  mb-4 mt-3  shadow h-100 w-100  rounded-4">

          <img className="mx-0 icon-logo" src={val.icon} alt="" />
          <h3 className="h3-heading text-start  fs-5 my-3"> {val.title}</h3>
          <p className="fs-6  lh-base" >{val.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CoreComponent4;
